"use client";
import React from "react";
import dynamic from "next/dynamic";
import { useTheme } from "../../contexts/useTheme";
import { Config, Template } from "src/types";
const Bg = dynamic(() => import("../../Icon").then((mod) => mod.Bg));
const Bg4 = dynamic(() => import("../../Icon").then((mod) => mod.Bg4));
const Bg3 = dynamic(() => import("../../Icon").then((mod) => mod.Bg3));
const backgroundComponentMap: {
  [key in Template]?: React.ComponentType;
} = {
  design1: Bg,
  design2: Bg3,
  design3: Bg4,
};

// ✅ A full component that can be used directly
export default function BackgroundComponent({
  serverConfig,
}: {
  serverConfig: Config;
}): React.ReactElement {
  const { config } = useTheme();
  const isDemoMode = process.env.NEXT_PUBLIC_DEMO_MODE === "true";

  const SelectedComponent =
    backgroundComponentMap[
      !isDemoMode ? serverConfig.template : (config?.template as Template)
    ] || Bg;

  return <SelectedComponent />;
}
